import { createBaseClient } from './base.client';
import { LOAN_OFFICER_API_BASE_URL, BRANCH_API_BASE_URL } from '@/config/env';

/**
 * Loan Officer API Client
 * Configured for Sales AI Backend API
 * Base URL includes everything up to and including /loanofficer
 */
export const loanOfficer = createBaseClient(
  LOAN_OFFICER_API_BASE_URL,
  'loanOfficer'
);

/**
 * Branch API Client
 * Configured for Sales AI Backend API
 * Base URL includes everything up to and including /branch
 */
export const branch = createBaseClient(BRANCH_API_BASE_URL, 'branch');
